import { Displays } from 'constants/layout';
import { MonoBehavior } from 'game/core/monoBehavior';
import { addToBackground } from 'game/core/Playable2DRootContainer';
import { getScreenSize } from 'game/core/screen';
import { EventName } from 'game/events/eventsName';
import { GameEvent } from 'game/events/gameEvent';
import { getBackgroundAtlasClass } from 'game/helpers/backgroundAtlases';

import { Layout } from 'game/LayoutManager';
import { Store } from 'game/store/gameStore';

import { Sprite, Container } from 'pixi.js';

export class BackgroundLevel extends MonoBehavior {
    sprite?: Sprite;
    container: Container;
    // isGradient = true;
    currentResolution = null as Displays | null;
    gameLoaded = false;
    constructor() {
        super();
        this.drawBackground = this.drawBackground.bind(this);
        GameEvent.add(EventName.CHANGE_BG, this.drawBackground);
        this.container = new Container();
        this.container.eventMode = 'static';
        GameEvent.add(EventName.GAME_INTRO_COMPLETED, () => {
            this.gameLoaded = true;
        });
        this.container.on('pointerdown', () => {
            GameEvent.emit(EventName.BACKGROUND_CLICKED);
        });
    }
    start() {
        this.drawBackground();
        addToBackground(this.container);
    }
    isGradientAsset() {
        return false;
        switch (Store.background) {
            case 'background_1':
            case 'background_2':
            case 'background_3':
            case 'background_4':
            case 'background_5':
            case 'background_6':
            case 'background_7':
            case 'background_8':
            case 'background_9':
            case 'background_10':
                return true;
        }
        return false;
    }

    async drawBackground() {
        if (this.gameLoaded) GameEvent.emit(EventName.SHOW_LOADER);

        // this.isGradient = this.isGradientAsset();
        // if (this.isGradient) {
        //     const spriteGradient = this.createBackgroundImg();

        //     if (spriteGradient) {
        //         await Assets.load(spriteGradient);
        //         GameEvent.emit(EventName.HIDE_LOADER);

        //         this.sprite?.removeFromParent();
        //         this.sprite?.destroy();

        //         this.sprite = Sprite.from(spriteGradient);
        //         this.sprite.anchor.set(0.5);
        //         this.sprite.zIndex = 1;
        //         addToBackground(this.sprite);
        //     }
        // } else {
        this.currentResolution = Layout.getDisplay();
        const folder = this.getFolder();
        const backgroundAtlas = getBackgroundAtlasClass(Store.background, folder);
        
        let sprite = null;
        if (backgroundAtlas) {
            const textures = await backgroundAtlas.getAllTextures();
            sprite = textures.length ? textures[0] : null;
        }
        if (this.gameLoaded) GameEvent.emit(EventName.HIDE_LOADER);
        GameEvent.emit(EventName.BACKGROUND_LOADED);

        if (sprite) {
            this.sprite?.removeFromParent();
            this.sprite?.destroy();

            this.sprite = Sprite.from(sprite);
            this.sprite.anchor.set(0.5);
            this.sprite.zIndex = 1;
            this.container.addChild(this.sprite);
        }
        // }
        GameEvent.emit(EventName.DESIGN_ASSET_SET);

        const { width, height } = getScreenSize();
        this.resize(width, height);
    }
    getFolder() {
        switch (this.currentResolution) {
            case Displays.MOBILE:
                return 'mobile';
            case Displays.TABLET:
                return 'tablet';
            default:
                return 'desktop';
        }
    }
    resize(width: number, height: number) {
        if (!this.sprite) return;
        // if (this.isGradient) {
        //     this.sprite.width = width;
        //     this.sprite.height = height;
        // } else {
        if (!this.currentResolution || this.currentResolution !== Layout.getDisplay()) {
            this.drawBackground();
        } else this.sprite.scale.set(Math.max(width / this.sprite.texture.width, height / this.sprite.texture.height));
        // }
    }

    // createBackgroundImg() {
    //     const { from, to } = this.getGradientSteps();
    //     const SIZE = 2400;
    //     const canvas = document.createElement('canvas');

    //     canvas.width = SIZE;
    //     canvas.height = SIZE;
    //     const ctx = canvas.getContext('2d');
    //     if (!ctx) return;
    //     const gradient = ctx.createRadialGradient(SIZE / 2, SIZE / 2, 0, SIZE / 2, SIZE / 2, SIZE / 2);

    //     // Add three color stops
    //     gradient.addColorStop(0, from);
    //     gradient.addColorStop(1, to);

    //     ctx.fillStyle = gradient;
    //     ctx.fillRect(0, 0, SIZE, SIZE);

    //     const img = document.createElement('img');
    //     // document.body.appendChild(img);
    //     return canvas.toDataURL();
    // }

    // getGradientSteps() {
    //     let from = '#1e8139';
    //     let to = '#176A33';
    //     switch (Store.background) {
    //         case 'background_1':
    //             from = '#1e8139';
    //             to = '#176A33';
    //             break;
    //         case 'background_2':
    //             to = '#418091';
    //             from = '#75BACD';
    //             break;
    //         case 'background_3':
    //             from = '#F9364E';
    //             to = '#7C2833';
    //             break;
    //         case 'background_4':
    //             from = '#F6AC3E';
    //             to = '#944E00';
    //             break;
    //         case 'background_5':
    //             to = '#1B7652';
    //             from = '#27BC81';
    //             break;
    //         case 'background_6':
    //             from = '#2BB9B1';
    //             to = '#006D67';
    //             break;
    //         case 'background_7':
    //             from = '#BD5A7C';
    //             to = '#573D46';
    //             break;
    //         case 'background_8':
    //             from = '#393E46';
    //             to = '#393E46';
    //             break;
    //         case 'background_9':
    //             from = '#6A6FC3';
    //             to = '#313357';
    //             break;
    //         case 'background_10':
    //             from = '#1F8031';
    //             to = '#185203';
    //             break;
    //     }
    //     return { from, to };
    // }
}
